var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3079 17.3055H18.0926L17.6618 16.8902C19.2216 15.081 20.0788 12.7714 20.0771 10.3828C20.0771 8.40508 19.4906 6.47178 18.3919 4.82738C17.2931 3.18297 15.7314 1.90131 13.9043 1.14447C12.0771 0.387633 10.0665 0.18961 8.12681 0.575443C6.1871 0.961275 4.40536 1.91363 3.00691 3.31209C1.60846 4.71054 0.656099 6.49228 0.270267 8.43199C-0.115566 10.3717 0.0824576 12.3823 0.839295 14.2094C1.59613 16.0366 2.87779 17.5983 4.5222 18.6971C6.16661 19.7958 8.09991 20.3823 10.0776 20.3823C12.5544 20.3823 14.8312 19.4746 16.585 17.967L17.0003 18.3978V19.6131L24.6923 27.2896L26.9844 24.9974L19.3079 17.3055ZM10.0776 17.3055C6.24704 17.3055 3.1549 14.2134 3.1549 10.3828C3.1549 6.55222 6.24704 3.46007 10.0776 3.46007C13.9082 3.46007 17.0003 6.55222 17.0003 10.3828C17.0003 14.2134 13.9082 17.3055 10.0776 17.3055Z",
    fill: "white",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.68a6dfa5fd1d9d059e98874b3ab08898.svg";
export { ForwardRef as ReactComponent };